<template>
  <section class="update-password-view" v-loading.fullscreen.lock="loading">
    <div class="profile-container">
      <div class="profile-content">
        <el-card class="account-card">
          <div class="account-header">ACCOUNT</div>
          <div class="profile-account-view">
            <ul>
              <li>
                <el-button
                  class="list-item-account-menu"
                  type="button"
                  @click="viewProfile()"
                >
                  <span class="account-icons">
                    <img
                      src="@/assets/images/icons/profile/personal-info.svg"
                      alt="icon"
                  /></span>
                  <span class="text">Personal Information</span>
                </el-button>
              </li>
              <li class="active">
                <el-button class="list-item-account-menu" type="button">
                  <span class="account-icons"
                    ><img
                      src="@/assets/images/icons/profile/reset-key-fill.svg"
                      alt="icon"
                  /></span>
                  <span class="text">Update Password</span>
                </el-button>
              </li>
              <li>
                <el-button class="list-item-account-menu" @click="logOut()">
                  <span class="account-icons"
                    ><img
                      src="@/assets/images/icons/profile/log-out2.svg"
                      alt="icon"
                  /></span>
                  <span class="text">Log Out</span>
                </el-button>
              </li>
            </ul>
          </div>
        </el-card>
      </div>

      <div class="password-right-block">
        <el-row class="">
          <el-col :span="24" class="">
            <div class="update-pass-header">
              <h4>Update Password</h4>
              <p>Please enter your current password to change your password</p>
            </div>
          </el-col>
          <el-col
            :xl="24"
            :lg="24"
            :md="24"
            :sm="24"
            :xs="24"
            class="update-password-col"
          >
            <div class="each-data-edit">
              <label for="text"> Current Password </label>
              <el-form class="form-input">
                <el-input
                  v-model="form.current_password"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  placeholder="Enter Current Password"
                />
                <el-button
                  class="show-eye-icon"
                  v-if="showCurrentPassword"
                  @click="showCurrentPassword = false"
                >
                  <img src="@/assets/images/icons/hide-eye-icon.svg" alt="" />
                </el-button>
                <el-button
                  class="hide-eye-icon"
                  @click="showCurrentPassword = true"
                  v-else
                >
                  <img src="@/assets/images/icons/show-eye-icon.svg" alt="" />
                </el-button>
              </el-form>
              <p class="err">
                <FormError errorName="current_password"></FormError>
              </p>
            </div>
          </el-col>
          <el-col
            :xl="24"
            :lg="24"
            :md="24"
            :sm="24"
            :xs="24"
            class="update-password-col"
          >
            <div class="each-data-edit">
              <label for="text"> Enter New Password </label>
              <el-form class="form-input">
                <el-input
                  v-model="form.new_password"
                  :type="showNewPassword ? 'text' : 'password'"
                  placeholder="Enter New Password"
                />
                <el-button
                  class="show-eye-icon"
                  v-if="showNewPassword"
                  @click="showNewPassword = false"
                >
                  <img src="@/assets/images/icons/hide-eye-icon.svg" alt="" />
                </el-button>
                <el-button
                  class="hide-eye-icon"
                  @click="showNewPassword = true"
                  v-else
                >
                  <img src="@/assets/images/icons/show-eye-icon.svg" alt="" />
                </el-button>
              </el-form>
              <p class="err pt-10">
                <FormError errorName="new_password"></FormError>
              </p>
              <p class="err">
                <FormError errorName="critical_error"></FormError>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="footer-btn">
      <el-button class="cancel-btn" @click="goBack()">CANCEL</el-button>
      <el-button class="save-btn" @click="updatePassword()"
        >UPDATE & SAVE</el-button
      >
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      form: { current_password: "", new_password: "" },
      loading: false,
      showNewPassword: false,
      showCurrentPassword: false,
    };
  },
  components: {
    FormError,
  },
  computed: {
    ...mapGetters("updatePassword", ["getPasswordUpdateStatus"]),
    ...mapGetters("errors", ["getErrors"]),
  },
  mounted() {},
  methods: {
    async updatePassword() {
      try {
        this.loading = true;
        await this.$store.dispatch("updatePassword/updatePassword", this.form);
        if (this.getPasswordUpdateStatus) {
          successNotification("Password Updated Successfully");
          await this.logOut();
        } else if (!this.getErrors) {
          errorNotification("Error in Update Password");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async logOut() {
      await this.$store.dispatch("globalReset");
      this.$router.push({ name: "signin" });
    },
    viewProfile() {
      this.$router.push("/user-profile");
    },
    goBack() {
      this.$router.push({ name: "AllCases" });
    },
  },
};
</script>

<style lang="scss">
.update-password-view {
  padding: 2em;
  max-width: 1200px;
  margin: 0 auto;
  .profile-container {
    display: grid;
    grid-template-columns: 300px auto;
    gap: 20px;
  }
  .profile-content {
    .account-card {
      border-radius: 10px;
      &.is-always-shadow {
        box-shadow: none;
        color: #34495e;
        font-weight: 600;
        border: 1px solid #e7e7f7;
      }
      .el-card__body {
        padding: 0;
      }
      .account-header {
        padding: 20px 20px 10px 20px;
        border-bottom: 0.5px solid #e7e7f7;
      }
    }
    .profile-account-view {
      ul {
        li {
          position: relative;
          &.active {
            .list-item-account-menu {
              background-color: #569ff210;
            }
            &::after {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              width: 3px;
              background-color: #215fad;
            }
          }
          .list-item-account-menu {
            border: none;
            font-weight: 400;
            font-size: 16px;
            width: 100%;
            color: #34495e;
            text-align: left;
            border-radius: 0;
            & > span {
              display: flex;
              align-items: center;
            }
            .account-icons {
              img {
                width: 18px;
                top: 1px;
                padding: 0 10px 0 0;
                position: relative;
              }
            }
            &:hover,
            &:focus,
            &:active {
              background: #56cbf210;
              color: #34495e;
            }
          }
        }
      }
    }
  }

  .password-right-block {
    background: #ffffff;
    border: 1px solid #e7e7f7;
    padding: 1.5em 0;
    border-radius: 10px;
    .update-pass-header {
      padding: 0.5rem 3rem;
      border-bottom: 0.5px solid #e7e7f7;
      h4 {
        font-weight: 600;
        line-height: 18px;
        font-size: 18px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: #233a73;
      }
      p {
        color: #000000;
        opacity: 0.65;
        font-size: 13px;
      }
    }

    .update-password-col {
      padding: 0.5rem 3rem;

      .each-data-edit {
        label {
          letter-spacing: 0.5px;
          font-size: 16px;
          margin-bottom: 5px !important;
          font-weight: 500;
          line-height: 15px;
          color: #4f4f4f;
        }
        .el-form-item {
          margin-bottom: 0px;
        }
        .form-input {
          width: 85%;
          position: relative;
          .hide-eye-icon {
            position: absolute;
            right: 2%;
            bottom: 0;
            padding: 0px 5px;
            border: none;
            background: none;

            img {
              width: 16px;
              height: 16px;
            }
          }
          .show-eye-icon {
            position: absolute;
            right: 2%;
            bottom: -2%;
            padding: 0px 5px;
            border: none;
            background: none;

            img {
              width: 16px;
              height: 16px;
            }
          }
          .el-input__inner {
            background: #ffffff;
            margin-top: 5px;
            border: 0.5px solid rgba(86, 204, 242, 0.8);
            box-sizing: border-box;
            border-radius: 3px;
          }
        }
        .el-input__suffix-inner .el-input__clear {
          color: #0a5da6;
        }
        .el-icon svg {
          width: 3em;
          height: 1.6em;
        }
      }
    }
  }
  .footer-btn {
    text-align: end !important;

    width: 100%;

    margin-top: 15px;
    padding-bottom: 1rem;
    .el-button {
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 10px;
      min-height: 36px;
      padding: 0px 15px;
      border: none;
      line-height: 4px;
      color: #4f4f4f;
      &.cancel-btn {
        background-color: #f24a55;
        color: #ffffff;

        &:hover,
        &:active {
          background-color: #f24a55;
          color: #ffffff;
        }
      }
      &.save-btn {
        background: #215fad;
        color: #ffffff;
      }
    }
  }
}
</style>
